<template>
	<b-modal
		id="create-tour"
		:title="$t('tours.name-tour')"
		@hidden="$emit('remove')"
		@ok="createTour"
	>
		<form @submit.stop.prevent="createTour">
			<b-form-group :label="$t('tours.name')" label-for="tour-name">
				<b-form-input
					id="tour-name"
					v-model="name"
					trim
					autofocus
				/>
			</b-form-group>
		</form>
	</b-modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
	name: 'CreateTour',
	data() {
		return { name: '' };
	},
	computed: { ...mapState(['openPanels']) },
	mounted() {
		this.$bvModal.show('create-tour');
	},
	methods: {
		...mapMutations(['addTour', 'openPanel']),
		async createTour() {
			const { data } = await this.axios.post(`${this.$route.path}/tours`, {
				data: { stops: [] },
				name: this.name,
			});
			this.addTour(data);
			if (!this.openPanels.visualizationTools.slim1.tools.some((tool) => tool.componentName === 'TourLibrary'))
				this.openPanel({
					area: 'visualizationTools',
					panel: { componentName: 'TourLibrary' },
					smartPanel: 'slim1',
				});
			this.$bvModal.hide('create-tour');
		},
	},
};
</script>